/** 1.3.0 portal strings shared by every stream (step 0's; streams add their own in their file). */
export const COMMON_STRINGS = {
  'common.appName': 'Media portal',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.retry': 'Try again',
  'common.loading': 'Loading…',
  'common.error': 'Something went wrong. Try again in a moment.',
  'error.PORTAL_DISABLED': 'The portal is not open at the moment.',
  'error.PORTAL_QUOTA': 'Your company has used its upload quota. Contact your PRISM contact.',
  'error.RIGHTS_REQUIRED': 'Confirm the rights declaration to submit.',
  'error.VIRUS_FOUND': 'The file was refused: the virus scanner found something in it.',
  'error.ASSIGNMENT_CANCELLED': 'This delivery was cancelled.',
  // 1.3.1 (step 0).
  'error.ASSIGNMENT_EXPIRED': 'This delivery has expired and takes no more files. Contact your PRISM contact if you still need to deliver it.',
} as const;
